// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Numeric {\n  font-feature-settings: \"tnum\";\n  font-variant-numeric: tabular-nums;\n}", "",{"version":3,"sources":["webpack://./src/react-ftm/types/Numeric.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EAAA,kCAAA;AACF","sourcesContent":[".Numeric {\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
